export const signupProps = {
    id: 0,
    first_name: '',
    last_name: '',
    brand_name: '',
    country_id: null,
    email_address: '',
    password: '',
    confirm_password: '',
    confirmation_code: '',
    tailoring_category: null
}


// WEBPACK FOOTER //
// ./src/store/modules/signup/properties.js